import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-landing',
  standalone: false,
  templateUrl: './admin-landing.component.html',
  styleUrls: ['./admin-landing.component.scss'],
})
export class AdminLandingComponent {
  constructor() { }

}
